module.exports = __webpack_public_path__ + "img/dreammobile.dc872b31.png";